import React, { useMemo } from 'react'
import LabelCard from './LabelCard'
import { ReactComponent as IconCow } from '../../../../assets/trace.svg'
import { ReactComponent as IconCowWhite } from '../../../../assets/tracewhite.svg'
import useOrderStore from 'store/client/orderStore'

const leatherTypes = [
  'BUFFALO FURSKIN',
  'BUFFALO LEATHER',
  'CALF FURSKIN',
  'COLT LEATHER',
  'COW FURSKIN',
  'GOAT LEATHER',
  'HORSE LEATHER',
  'LAMB FURSKIN',
  'LAMBSKIN',
  'PIG FURSKIN',
  'PIG LEATHER',
  'RABBIT LEATHER',
  'SHEEP FURSKIN',
  'SHEEP LEATHER',
]

const getType = (number) =>
  number % 2 === 0 ? 'back' : 'front'

export default function MultiFabricLabels({
  data: { washingLabel },
}) {
  const { referance } = useOrderStore()

  const isBlackLabel =
    referance?.backgroundColor === 'B'

  return useMemo(() => {
    const fabricItems = washingLabel?.[0]?.fabric ?? []

    if (!fabricItems.length) {
      return {
        cards: [],
        lastNumber: 5,
      }
    }

    const isLeatherType = fabricItems.some((item) =>
      item?.mix?.some((mix) =>
        leatherTypes.includes(mix?.type)
      )
    )

    const LeatherIcon = isBlackLabel
      ? IconCowWhite
      : IconCow

    const cards = []
    let number = 5

    fabricItems.forEach((item) => {
      if (!item?.mix?.length) return

      let currentCardContents = []
      let currentCardLength = 0

      const addCard = () => {
        if (!currentCardContents.length) return

        const cardNumber = number
        const cardContents = [...currentCardContents]

        cards.push(
          <LabelCard
            key={`fabric-${cardNumber}`}
            className="pdf-force text-[5.9pt] leading-[5.7pt] px-[2.5mm]"
            number={cardNumber}
            type={getType(cardNumber)}
          >
            <div className="flex flex-col items-center justify-center h-full pt-1 -mt-[2px]">
              {cardContents.map((content, index) => {
                if (!content) return null

                const [percent, text] = content.split('%')
                const isFabric = percent.length > 3

                return (
                  <div
                    key={`${cardNumber}-${index}`}
                    className="flex items-center gap-x-[2px] text-left mt-[5px] text-[5.9pt] scale-y-[120%]"
                    style={{
                      paddingTop:
                        cardNumber === 8 && isFabric
                          ? '5px'
                          : '0px',
                      transform: `scaleY(${
                        cardNumber === 8 && isFabric
                          ? 1.04
                          : 1.2
                      })`,
                      fontFamily: 'PdfSafe',
                    }}
                  >
                    <div
                      className="flex flex-col"
                      style={{ marginBottom: 7 }}
                    >
                      <div
                        className={
                          percent.length <= 3
                            ? 'w-[20px]'
                            : ''
                        }
                      >
                        <span>
                          {isFabric
                            ? percent
                            : `${percent}%`}
                        </span>
                      </div>

                      {isLeatherType &&
                        cardNumber === 6 && (
                          <LeatherIcon
                            style={{
                              width: '4.968mm',
                              height: '4.468mm',
                              marginTop: '2px',
                            }}
                            preserveAspectRatio="none"
                          />
                        )}
                    </div>

                    <div>{text}</div>
                  </div>
                )
              })}
            </div>
          </LabelCard>
        )

        number += 1
        currentCardContents = []
        currentCardLength = 0
      }

      if (item.text && item.text.length <= 350) {
        currentCardContents.push(item.text)
        currentCardLength += item.text.length
      }

      item.mix.forEach((mix) => {
        if (
          !mix?.text ||
          !mix?.percent ||
          !mix.text.length
        ) {
          return
        }

        const mixText = `${mix.percent}% ${mix.text}`

        if (
          currentCardLength + mix.text.length <= 320
        ) {
          currentCardContents.push(mixText)
          currentCardLength += mix.text.length
        } else {
          addCard()

          currentCardContents.push(mixText)
          currentCardLength = mix.text.length
        }
      })

      addCard()
    })

    return {
      cards,
      lastNumber: number,
    }
  }, [washingLabel, isBlackLabel])
}